import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const roleGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const requiredRole = route.data['role'] as 'Admin' | 'Manager' | 'Crew';

  if (!requiredRole) {
    return true;
  }

  if (auth.hasAccess(requiredRole)) {
    return true;
  }

  return router.createUrlTree(['/']);
};